/**
 * Endpoints whose 401 does NOT mean "your session expired".
 *
 * SessionInterceptor turns any other 401 into a logout, an "expired" toast and a redirect to
 * /login. That is right for a request made as a signed-in user, and wrong for an anonymous
 * endpoint where 401 is the answer to what was asked rather than a statement about a session —
 * there is no session to have expired. Left off this list, such an endpoint navigates the user
 * away before its own error handling can run.
 *
 * Matched with endsWith against the request URL, so entries must be the full path.
 */
export const IGNORED_SESSION_EXPIRY_URLS = [
	'/api/authorization/login',
	// Anonymous. 401 here means the password reset token was rejected — expired, already used, or
	// unknown — which the reset page handles by offering the customer a fresh link.
	'/api/account/reset-password',
	// 401 is a wrong two-factor code, which the login step reports with the attempts left. Treated as an
	// expired session it logged the user out and sent them back to the start mid-sign-in.
	'/api/authorization/validate-2fa',
	// Anonymous. 401 is a wrong or locked-out emailed code for a returning guest.
	'/api/authorization/guest-login',
	'/api/register/convert-guest',
];
